import {
  CONCERT_INFO_BACKGROUND,
  MOBILE_SPECIAL_CONCERT_INFO1,
  MOBILE_SPECIAL_CONCERT_INFO2,
  MOBILE_SPECIAL_CONCERT_INFO3,
  SPECIAL_CONCERT_INFO1,
  SPECIAL_CONCERT_INFO2,
} from 'src/assets/database/webData';
import { FlexBox, FlexBoxFullWidth } from 'src/styles/OverviewStyle';
import styled from 'styled-components';

export default function WebConcertInfoSpecial() {
  const isMobile = window.innerWidth < 1280;
  return (
    <ContainerWebConcertInfo>
      <ConcertInfoSelectBlock>
        <h1>공연 예약하기</h1>
        <ConcertInfoBookButton
          onClick={() =>
            window.open(
              'https://www.jejusi.go.kr/acenter/show/perf/view.do?showId=1613',
            )
          }
        >
          예약하기
        </ConcertInfoBookButton>
      </ConcertInfoSelectBlock>
      {isMobile ? (
        <ConcertBackgroundImageBoardMobile>
          <ConcertImageBoard src={MOBILE_SPECIAL_CONCERT_INFO1} />
          <ConcertImageBoard src={MOBILE_SPECIAL_CONCERT_INFO2} />
          <ConcertImageBoard src={MOBILE_SPECIAL_CONCERT_INFO3} />
        </ConcertBackgroundImageBoardMobile>
      ) : (
        <ConcertBackgroundImageBoard>
          <ConcertImageBoard src={SPECIAL_CONCERT_INFO1} />
          <ConcertImageBoard src={SPECIAL_CONCERT_INFO2} />
        </ConcertBackgroundImageBoard>
      )}
    </ContainerWebConcertInfo>
  );
}
const ContainerWebConcertInfo = styled(FlexBox)`
  width: 100%;

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;
const ConcertInfoSelectBlock = styled(FlexBox)`
  width: 100%;
  padding: 40px 0 44px 0;

  background-color: #f0f1f4;

  flex-direction: column;
  justify-content: center;
  align-items: center;
  > h1 {
    color: var(--Font-02_black, #111);
    text-align: center;
    font-family: Cafe24Ohsquare;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: -0.08px;
    margin-bottom: 12px;
  }
`;
const ConcertInfoBookButton = styled.button`
  width: 160px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 24px;
  background: #4d4a96;

  color: #fcfcfd;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.04px;
`;

const ConcertBackgroundImageBoard = styled(FlexBoxFullWidth)`
  width: 100%;
  background-image: url(${CONCERT_INFO_BACKGROUND});
  background-size: cover;
  background-position: top;

  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 1600px) {
    width: 101%;
  }
`;

const ConcertBackgroundImageBoardMobile = styled(FlexBoxFullWidth)`
  width: 100%;

  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ConcertImageBoard = styled.img`
  width: 1000px;
  margin: 0 auto;

  @media screen and (max-width: 1280px) {
    width: 100%;
  }
`;
